import ReducerUtils      from "../../utils/ReducerUtils"
import Actions           from "../../model/constant/actions"

export const IsMenuToggle = ReducerUtils.createReducer<boolean>(true,{
  [Actions.TOGGLE_MENU] : (state)=>!state
})
